import { Stack, Text } from "@mantine/core"
import type { AgencyAffiliation } from "../AgencyAffiliationsTypes"
import {
	useAEMDictionary,
	AEM_DICTIONARY_COLLECTIONS
} from "@AEM/hooks/useAEMDictionary"
interface AgencyAddressBlockProps {
	agency: AgencyAffiliation
}

const AgencyAddressBlock = ({ agency }: AgencyAddressBlockProps) => {
	const { dictionary } = useAEMDictionary(
		AEM_DICTIONARY_COLLECTIONS.REGISTRATION
	)
	const abta = agency.abta?.trim()
	const phone = agency.phone?.trim()

	return (
		<Stack gap={0}>
			{abta ? (
				<Text fz={16} lh={1.4} c="var(--text-color-primary)">
					ABTA: {abta}
				</Text>
			) : phone ? (
				<Text fz={16} lh={1.4} c="var(--text-color-primary)">
					{dictionary?.maphoneLabel ?? ""} {phone}
				</Text>
			) : null}

			{agency.address1 && (
				<Text fz={16} lh={1.4} c="var(--text-color-primary)">
					{agency.address1}
				</Text>
			)}
			{(agency.city || agency.state || agency.zip) && (
				<Text fz={16} lh={1.4} c="var(--text-color-primary)">
					{[agency.city, agency.state, agency.zip].filter(Boolean).join(", ")}
				</Text>
			)}
			{agency.country && (
				<Text fz={16} lh={1.4} c="var(--text-color-primary)">
					{agency.country}
				</Text>
			)}
		</Stack>
	)
}

export default AgencyAddressBlock
